import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function Accommodation() {
  return (
    <section className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-lg px-6 text-center">
        <ScrollReveal>
          <p className="micro-label mb-5 text-foreground-500">Hospedaje</p>
          <div className="mx-auto h-px w-16 bg-primary-300" />
        </ScrollReveal>

        <ScrollReveal delay={1}>
          <div className="mt-10 space-y-3">
            <p className="font-heading text-xl font-light text-foreground-800 sm:text-2xl md:text-3xl">
              {weddingConfig.hotelName}
            </p>
            <p className="font-body text-sm leading-relaxed text-foreground-500 sm:text-base">
              {weddingConfig.hotelAddress}
            </p>
            {weddingConfig.hotelReservationInfo && (
              <p className="font-body text-sm leading-relaxed text-foreground-500 sm:text-base">
                {weddingConfig.hotelReservationInfo}
              </p>
            )}
          </div>
        </ScrollReveal>

        <ScrollReveal delay={2}>
          <div className="mt-10 md:mt-12">
            <a
              href={weddingConfig.hotelReservationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline hover:bg-background-50"
            >
              <i className="ri-calendar-check-line text-sm" />
              Reservar
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}